const SEO = [
	{
	  page: "home",
	  description: "Kirunda Brian | Full-Stack Developer | WordPress & Node.js Specialist | Building scalable digital solutions for African businesses and global clients.",
	  keywords: [
		"WordPress developer Uganda",
		"Node.js engineer Kampala",
		"Headless WordPress",
		"Kirunda Brian portfolio",
		"Full-stack developer Africa",
		"WooCommerce expert"
	  ],
	},
	{
	  page: "about",
	  description: "WordPress specialist with 5+ years experience creating high-performance sites and custom plugins. Also skilled in Node.js backend development for complex web applications.",
	  keywords: [
		"Ugandan WordPress developer",
		"Custom WordPress themes",
		"WordPress optimization",
		"Node.js backend services",
		"WordPress REST API",
		"Elementor expert"
	  ],
	},
	{
	  page: "articles",
	  description: "WordPress tutorials, Node.js integration guides, and insights on building hybrid CMS architectures for optimal performance in emerging markets.",
	  keywords: [
		"WordPress best practices",
		"Headless CMS Africa",
		"WordPress performance",
		"Node.js with WordPress",
		"GraphQL WordPress",
		"JAMstack tutorials"
	  ],
	},
	{
	  page: "projects",
	  description: "Featured work: Enterprise WordPress sites handling 50K+ visits/month, custom WooCommerce solutions, and Node.js-powered WordPress REST API integrations.",
	  keywords: [
		"WordPress case studies",
		"WooCommerce projects",
		"WordPress-Node.js integration",
		"African ecommerce solutions",
		"WordPress multilingual sites",
		"CMS migration projects"
	  ],
	},
	{
	  page: "contact",
	  description: "Need a WordPress expert who also understands backend development? Let's discuss your website or web application project with both CMS flexibility and custom functionality.",
	  keywords: [
		"Hire WordPress developer",
		"WordPress maintenance Uganda",
		"WordPress to Node.js migration",
		"WordPress API development",
		"WordPress consulting Africa"
	  ],
	},
  ];
  
  export default SEO;